
import moment from 'moment'
import freeGoodIcon from '~/assets/img/freegood__icon.svg'
export default {
  name: 'ProductFreeGoodInfo',
  props: {
    freeGood: {
      type: Object,
      default() {
        return {
          promo_text: null,
          valid_to: null,
        }
      },
    },
    withPopover: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      freeGoodIcon,
    }
  },
  computed: {
    text() {
      return `${this?.freeGood?.promo_text} [EXP. ${this.formatDate(
        this.freeGood.valid_to
      )}]`
    },
  },
  methods: {
    formatDate(date) {
      return date ? moment(date).format('MM/DD/YY') : null
    },
  },
}
